import React, { createContext, useContext, useState } from 'react';

const AuthModalContext = createContext();

export const AuthModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState('login'); // 'login' or 'register'

  const openLoginModal = () => {
    setModalType('login');
    setIsModalOpen(true);
  };

  const openRegisterModal = () => {
    setModalType('register');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const switchModal = (type) => {
    if (type === 'login' || type === 'register') {
      setModalType(type);
    } else {
      setModalType(prev => prev === 'login' ? 'register' : 'login');
    }
  };

  return (
    <AuthModalContext.Provider value={{
      isModalOpen,
      modalType,
      openLoginModal,
      openRegisterModal,
      closeModal,
      switchModal
    }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => {
  return useContext(AuthModalContext);
};
